export default "__VITE_ASSET__CaAQeBgG__"